
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { AuthProvider, useAuth } from './context/AuthContext'
import './App.css'

import LandingLayout from './layouts/LandingLayout'
import PrivacyPage from './pages/PrivacyPage'

import ConfirmPage from './pages/ConfirmPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import Index from './pages/index'
import Home from './pages/Home'
import UserProfile from './pages/UserProfile'
import SupportTickets from './pages/SupportTickets'

import AdminPanel from './pages/AdminPanel'
import AdminMembershipTypes from './pages/AdminMembershipTypes'
import AdminMlmBonusLevels from './pages/AdminMlmBonusLevels'
import AdminUsers from './pages/AdminUsers'
import AdminNetworkViz from './pages/AdminNetworkViz'
import AdminCashbackLab from './pages/AdminCashbackLab'
import AdminReceipts from './pages/AdminReceipts'
import AdminWallet from './pages/AdminWallet'
import PaymentAllocationsAdmin from './pages/PaymentAllocationsAdmin'
import AdminLedger from './pages/admin/ledger/AdminLedger'
import AdminAuditLogs from './pages/AdminAuditLogs'
import AdminInsurance from './pages/AdminInsurance'
import AdminPromoBanners from './pages/AdminPromoBanners'

import ServerUnavailableModal from './components/ServerUnavailableModal'
import FloatingPromoBanner from './components/FloatingPromoBanner'
import MatomoRouteTracker from './components/MatomoRouteTracker'

const PrivateRoute = ({ element }) => {
  const { user, loading } = useAuth()

  if (loading) return null

  if (!user) {
    return <Navigate to="/" replace />
  }

  return element
}

const AdminRoute = ({ element }) => {
  const { user, loading } = useAuth()

  if (loading) return null
  if (!user) return <Navigate to="/" replace />
  if (user.role !== 'admin') return <Navigate to="/home" replace />

  return element
}

const AppContent = ({ serverDown, setServerDown }) => {
  const location = useLocation()
  const isSupportDomain = window.location.hostname === 'support.enerqiq.net'
  const isSupport =
    location.pathname === '/support' || isSupportDomain

  return (
    <>
      <MatomoRouteTracker />

      <ServerUnavailableModal
        open={serverDown}
        onClose={() => setServerDown(false)}
      />

      <Routes>
        <Route element={<LandingLayout />}>
          <Route
            path="/"
            element={isSupportDomain ? null : <Index />}
          />

          <Route path="/privacy" element={<PrivacyPage />} />

          <Route
            path="/home"
            element={<PrivateRoute element={<Home />} />}
          />

          <Route
            path="/userprofile"
            element={<PrivateRoute element={<UserProfile />} />}
          />

          <Route
            path="/reset/:token"
            element={<><Index /><ResetPasswordPage /></>}
          />

          <Route
            path="/confirm/:token"
            element={<><Index /><ConfirmPage /></>}
          />
        </Route>

        {isSupportDomain && (
          <Route
            path="/"
            element={<SupportTickets />}
          />
        )}

        <Route
          path="/support"
          element={<SupportTickets />}
        />

        <Route
          path="/admin"
          element={<AdminRoute element={<AdminPanel />} />}
        />

        <Route
          path="/admin/membership-types"
          element={<AdminRoute element={<AdminMembershipTypes />} />}
        />

        <Route
          path="/admin/mlm-bonus-levels"
          element={<AdminRoute element={<AdminMlmBonusLevels />} />}
        />

        <Route
          path="/admin/insurance"
          element={<AdminRoute element={<AdminInsurance />} />}
        />

        <Route
          path="/admin/users"
          element={<AdminRoute element={<AdminUsers />} />}
        />

        <Route
          path="/admin/network-viz"
          element={<AdminRoute element={<AdminNetworkViz />} />}
        />

        <Route
          path="/admin/cashback-lab"
          element={<AdminRoute element={<AdminCashbackLab />} />}
        />

        <Route
          path="/admin/receipts"
          element={<AdminRoute element={<AdminReceipts />} />}
        />

        <Route
          path="/admin/wallet-entries"
          element={<AdminRoute element={<AdminWallet />} />}
        />

        <Route
          path="/admin/payment-allocations"
          element={<AdminRoute element={<PaymentAllocationsAdmin />} />}
        />

        <Route
          path="/admin/ledger"
          element={<AdminRoute element={<AdminLedger />} />}
        />

        <Route
          path="/admin/audit-logs"
          element={<AdminRoute element={<AdminAuditLogs />} />}
        />

        <Route
          path="/admin/promo-banners"
          element={<AdminRoute element={<AdminPromoBanners />} />}
        />
      </Routes>

      {!isSupport && <FloatingPromoBanner />}
    </>
  )
}

function App() {
  const [serverDown, setServerDown] = useState(false)

  useEffect(() => {
    const handler = () => setServerDown(true)

    window.addEventListener('server-unavailable', handler)

    return () => {
      window.removeEventListener('server-unavailable', handler)
    }
  }, [])

  return (
    <AuthProvider>
      <Router>
        <AppContent
          serverDown={serverDown}
          setServerDown={setServerDown}
        />
      </Router>
    </AuthProvider>
  )
}

export default App
